//messages.js
export default {
    bill_id: "Bill #",
    purchase_order_id: "Purchase Order #",
    billing_address_id: "Billing Address",
    shipping_address_id: "Shipping Address",
    shipping_carrier_id: "Shipping Carrier",
    bill_number: "Bill #",
    bill_date: "Bill Date",
    due_date: "Due Date",
    exchange_rate_id: "Exchange Currency",
    exchange_rate: "Exchange Rate",
    status_id: "Status",
    work_order_no: "Work Order No",
    subtotal: "Subtotal",
    discount: "Discount",
    total_amount: "Total Amount",
    customer_po: "Customer PO",
    comments: "Comments",
    edit_vendor_invoice: "Edit Bill",
    add_vendor_invoice: "Add Bill",
    delete_vendor_invoice: "Delete Bill",
    bills: "Bills",
    vendor_invoice_number: "Invoice #",

    /* bill_details */
    part_id: "Part #",
    sales_unit: "Sales Unit",
    price: "Price",
    quantity: "Quantity",
    line_total: "Line Total",
    edit_vendor_invoice_detail: "Edit Bill Detail",
    add_vendor_invoice_detail: "Add Bill Detail",
    delete_vendor_invoice_detail: "Delete Bill Detail",
    bill_details: "Bill Details",
    delete_vendor_invoice_confirm: "Are you sure you want to delete this bill?",

    payment_id: "Payment",
    bill_id: "Bill #",
    company_id: "Company",
    payment_date: "Payment Date",
    payment_method: "Payment Method",
    payment_status: "Payment Status",
    amount: "Amount",
    currency_id: "Currency",
    exchange_rate: "Exchange Rate",
    payment_method_id: "Payment Method",
    payment_status_id: "Payment Status",
    reference_number: "Reference Number",
    notes: "Notes",
    edit_bill_payment: "Edit Payment",
    add_bill_payment: "Make Payment",
    delete_bill_payment: "Delete Payment",
    bill_payments: "Bill Payments",
    delete_bill_payment_confirm: "This action is not reversible!",
    payment_larger_than_balance: "Payment amount is larger than the balance.",
    mark_as_archived: "Mark as Archived",
    mark_as_disputed: "Mark as Disputed",
    mark_as_on_hold: "Mark as On Hold",
    mark_as_overdue: "Mark as Overdue",
    mark_as_partially_paid: "Mark as Partially Paid",
    mark_as_pending: "Mark as Pending",
};
